export function escapeHtml(str) {
  return String(str)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

export function escapeRegExp(str) {
  return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function buildExcerpt(content, query) {
  const raw = (content || '').replace(/\s+/g, ' ').trim()
  if (!raw) return 'Attachment or empty message'

  const normalizedQuery = (query || '').trim()
  if (!normalizedQuery) return escapeHtml(raw.slice(0, 120))

  const lowerRaw = raw.toLowerCase()
  const lowerQuery = normalizedQuery.toLowerCase()
  const matchIndex = lowerRaw.indexOf(lowerQuery)

  if (matchIndex < 0) return escapeHtml(raw.slice(0, 120))

  const start = Math.max(0, matchIndex - 60)
  const end = Math.min(raw.length, matchIndex + normalizedQuery.length + 50)
  const excerpt = raw.slice(start, end)
  const prefix = start > 0 ? '... ' : ''
  const suffix = end < raw.length ? ' ...' : ''

  return escapeHtml(`${prefix}${excerpt}${suffix}`)
}

export function highlightQuery(escapedText, query) {
  const cleanQuery = (query || '').trim()
  if (!cleanQuery) return escapedText

  const pattern = new RegExp(`(${escapeRegExp(cleanQuery)})`, 'ig')
  return escapedText.replace(pattern, '<mark class="bg-amber-300/40 text-amber-100 px-0.5 rounded">$1</mark>')
}

export function formatSearchTimestamp(value) {
  if (!value) return ''

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''

  const diffSeconds = Math.floor((Date.now() - date.getTime()) / 1000)
  if (diffSeconds < 60) return 'now'
  if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)}m`
  if (diffSeconds < 86_400) return `${Math.floor(diffSeconds / 3600)}h`
  if (diffSeconds < 604_800) return `${Math.floor(diffSeconds / 86_400)}d`

  return date.toLocaleDateString()
}
